import { render, staticRenderFns } from "./Intervention.vue?vue&type=template&id=3964d9b8&scoped=true&"
import script from "./Intervention.vue?vue&type=script&lang=js&"
export * from "./Intervention.vue?vue&type=script&lang=js&"
import style0 from "./Intervention.vue?vue&type=style&index=0&id=3964d9b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3964d9b8",
  null
  
)

export default component.exports